import { object, mixed, string } from "yup";

export const etdUpdateValidation = object({
  date: mixed().required("Estimated time of delivery is required"),
  reason: string().required("Reason is required"),
});
